import { TRAVEL_MODES_IS_ACTIVE_DEFAULT } from '../constants';
import * as types from '../types';

function setTravelModeValue(state, action) {
    const {
        meta: {
            filterId,
            travelMode,
        },
        payload: value,
    } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            travelModes: {
                ...state[filterId].travelModes,
                [travelMode]: value,
            },
        },
    };
}

function resetTravelModes(state, action) {
    const { meta: filterId } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            travelModes: Object.keys(state[filterId].travelModes)
                .reduce((map, travelMode) => ({
                    ...map,
                    [travelMode]: TRAVEL_MODES_IS_ACTIVE_DEFAULT,
                }), {}),
        },
    };
}

export default {
    [types.SET_TRAVEL_MODE_VALUE]: setTravelModeValue,
    [types.RESET_TRAVEL_MODES]: resetTravelModes,
};
